import { buildProps, definePropType } from '@sgui-plus/utils/props'
import type { Component } from 'vue'

export const modalContentProps = buildProps({
  modalType: {
    type: String,
    values: ['confirm', 'alert', 'form'] as const,
    default: 'confirm'
  },
  promptType: {
    type: definePropType<string | Component>([String, Object]),
    default: ''
  },
  center: {
    type: Boolean,
    default: false,
  },
  closeIcon: {
    type: definePropType<string | Component>([String, Object]),
    default: '',
  },
  customClass: {
    type: String,
    default: '',
  },
  draggable: {
    type: Boolean,
    default: false,
  },
  fullscreen: {
    type: Boolean,
    default: false,
  },
  closable: {
    type: Boolean,
    default: true,
  },
  maximize: {
    type: Boolean,
    default: false,
  },
  minimize: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
  okText: {
    type: String,
    default: '确定'
  },
  cancelText: {
    type: String,
    default: '取消'
  },
  okClass: {
    type: String,
    default: ''
  },
  cancelClass: {
    type: String,
    default: ''
  },
  footerHide: {
    type: Boolean,
    default: false
  },
  showOk: {
    type: Boolean,
    default: true
  },
  showCancel: {
    type: Boolean,
    default: true
  }
} as const)

export const modalContentEmits = {
  confirm: () => true,
  close: () => true
}
